// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_hIM","cls2":"SimplePaperPodcast-cls2_zX5 SimplePaperPodcast-cls1_hIM"};